import { Modal } from '@carbon/react';
import { MessageDescriptor, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';

type Props = {
    open: boolean;
    isLoading?: boolean;
    heading: MessageDescriptor;
    label: MessageDescriptor;
    description: MessageDescriptor;
    primaryButtonText: MessageDescriptor;
    secondaryButtonText: MessageDescriptor;
    onClose: () => void;
    onPrimaryAction: () => void;
    onSecondaryAction: () => void;
};

const ExitSetupModal = ({
    open,
    isLoading = false,
    heading,
    label,
    description,
    primaryButtonText,
    secondaryButtonText,
    onClose,
    onPrimaryAction,
    onSecondaryAction,
}: Props) => {
    const intl = useIntl();

    return (
        <Modal
            open={open}
            onRequestClose={() => {
                if (isLoading) {
                    return;
                }

                onClose();
            }}
            onRequestSubmit={onPrimaryAction}
            modalHeading={intl.formatMessage(heading)}
            modalLabel={intl.formatMessage(label)}
            primaryButtonText={intl.formatMessage(primaryButtonText)}
            secondaryButtonText={intl.formatMessage(secondaryButtonText)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            onSecondarySubmit={onSecondaryAction}
            primaryButtonDisabled={isLoading}
            loadingStatus={isLoading ? 'active' : undefined}
        >
            <p>{intl.formatMessage(description)}</p>
        </Modal>
    );
};

export default ExitSetupModal;
